
const $ = jQuery.noConflict();

'use strict';
const EqualHeights = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.equalHeights();
		this.equalHeightsProductUpperText();
		this.equalHeightsBlogListing();
	},

	/** @description slider example description e.g Banner slider */
	equalHeightsGlobal: (elm) => {
		let x = 0;
		elm.height('auto');

		elm.each((index, el) => {
			if ($(el).height() > x) {
				x = $(el).height();
			}
		});

		elm.height(x + 1);
	},

	equalHeights: ()=> {
		EqualHeights.equalHeightsGlobal($('.product-box__info-text'));

		$(window).on('resize', function() {
			EqualHeights.equalHeightsGlobal($('.product-box__info-text'));
		});

		$(window).on('load', function() {
			EqualHeights.equalHeightsGlobal($('.product-box__info-text'));
		});
	},

	equalHeightsProductUpperText: ()=> {
		EqualHeights.equalHeightsGlobal($('.js-product-box__info-upper-text'));

		$(window).on('resize', function() {
			EqualHeights.equalHeightsGlobal($('.js-product-box__info-upper-text'));
		});

		$(window).on('load', function() {
			EqualHeights.equalHeightsGlobal($('.js-product-box__info-upper-text'));
		});
	},

	equalHeightsBlogListing: ()=> {
		EqualHeights.equalHeightsGlobal($('.blog-listing__bottom-box-desc'));

		$(window).on('resize', function() {
			EqualHeights.equalHeightsGlobal($('.blog-listing__bottom-box-desc'));
		});

		$(window).on('load', function() {
			EqualHeights.equalHeightsGlobal($('.blog-listing__bottom-box-desc'));
		});
	}
};

export default EqualHeights;
